import { styled } from '@mui/material/styles';
import { RADIO_BORDER_HOVER_COLOR_VAR } from '../../theme/constants/radio';

const FingoRadio = styled('span', {
  shouldForwardProp: (prop) => prop !== 'size',
})(({ theme, size = 24 }) => ({
  borderRadius: '50%',
  width: size,
  height: size,
  [theme.breakpoints.down('md')]: {
    width: size * 0.75,
    height: size * 0.75,
  },
  backgroundColor: 'white',
  border: '1px solid',
  borderColor: theme.palette.gray.A300,
  transition: 'border-color 0.2s ease',
  '&:hover': {
    borderColor: `var(${RADIO_BORDER_HOVER_COLOR_VAR}, ${theme.palette.primary.main})`,
  },
}));

export default FingoRadio;
